if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        // Corrigido: Aceder ao input pelo nome ou ID, não como propriedade direta da classe
        this.variantIdInput = this.form.querySelector('[name="id"]');
        if (this.variantIdInput) { // Verificar se o input existe antes de o ativar
           this.variantIdInput.disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        // Corrigido: Aceder ao span dentro do botão de forma mais segura
        this.submitButtonText = this.submitButton?.querySelector('span'); // Usar optional chaining

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault(); // Previne submissão padrão

        // Verifica se o botão está desativado
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Limpa mensagens de erro anteriores
        this.handleErrorMessage();

        // Define estado de loading
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner'); // Obter o spinner
        if (loadingSpinner) loadingSpinner.classList.remove('hidden'); // Mostrar spinner se existir

        // --- Adiciona verificação de largura de ecrã ---
        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // --- Lógica Condicional ---
        if (isMobile) {
          // --- Comportamento Mobile: Adicionar e Redirecionar ---
          // Não precisamos adicionar 'sections' ou 'sections_url' para mobile
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config) // Usa a rota definida globalmente
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                // Erro ao adicionar (ex: stock)
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
                this.error = true; // Marca que houve erro
                // Reativa o botão apenas se houver erro
                this.submitButton.removeAttribute('aria-disabled');
                this.submitButton.classList.remove('loading');
                if (loadingSpinner) loadingSpinner.classList.add('hidden');
                return;
              }

              // Sucesso: Redirecionar para a página do carrinho
              const cartUrl = window.routes?.cart_url || '/cart';
              window.location.href = cartUrl;
              // Não reativamos o botão aqui porque a página vai mudar
            })
            .catch((e) => {
              console.error(e);
              this.handleErrorMessage('Error connecting to cart.'); // Mostra erro genérico
              this.error = true; // Marca que houve erro
              // Reativa o botão em caso de erro de fetch
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.classList.remove('loading');
              if (loadingSpinner) loadingSpinner.classList.add('hidden');
            });

        } else {
          // --- Comportamento Desktop: AJAX e Abrir Popup/Drawer (Lógica Original Adaptada) ---
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', 'true');
                 if (this.submitButtonText) this.submitButtonText.classList.add('hidden'); // Verifica se existe
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return; // Sai aqui em caso de erro de stock
              } else if (!this.cart) {
                 // Fallback se não houver cart drawer/notification (já existia)
                window.location.href = window.routes?.cart_url || '/cart';
                return;
              }

               // Se chegou aqui, foi sucesso e é desktop com cart drawer/notification
              const startMarker = CartPerformance?.createStartingMarker('add:wait-for-subscribers'); // Usa optional chaining
              this.error = false; // Garante que não há erro marcado

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                 CartPerformance?.measureFromMarker('add:wait-for-subscribers', startMarker); // Usa optional chaining
              });

              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance?.measure("add:paint-updated-sections", () => { // Usa optional chaining
                        this.cart?.renderContents(response); // Usa optional chaining
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                 CartPerformance?.measure("add:paint-updated-sections", () => { // Usa optional chaining
                   this.cart?.renderContents(response); // Usa optional chaining
                 });
              }
            })
            .catch((e) => {
              console.error(e);
              this.handleErrorMessage('Error connecting to cart.');
              this.error = true; // Marca erro em caso de falha de fetch
            })
            .finally(() => {
              // Executa sempre no final do fetch (sucesso ou erro) para desktop
              this.submitButton.classList.remove('loading');
              if (loadingSpinner) loadingSpinner.classList.add('hidden');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              // Só reativa o botão se não tiver ocorrido um erro que o deva manter desativado
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');

              CartPerformance?.measureFromEvent("add:user-action", evt); // Usa optional chaining
            });
        } // Fim do else (Desktop)
      } // Fim do onSubmitHandler

      handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;

          this.errorMessageWrapper =
              this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

          if (errorMessage && this.errorMessage) { // Verifica se errorMessage existe
              this.errorMessage.textContent = errorMessage;
          }
      }

      // A função toggleSubmitButton não parece ser usada no onSubmitHandler original,
      // mas pode ser mantida se for usada por outros eventos (ex: mudança de variante)
      /*
      toggleSubmitButton(disable = true, text) {
          // ... (código original)
      }
      */

      // A propriedade variantIdInput foi movida para o constructor para melhor prática
      /*
      get variantIdInput() {
        // ... (código original)
      }
      */
    } // Fim da classe ProductForm
  );
}